import type { PropsWithChildren } from 'react'
import { useContext } from 'react'
import * as React from 'react'

interface MetaOffersDiscountState {
  loading: boolean
  packages?: App.FeedOperations['getOfferDiscount']['responses']['200']['content']['application/json']['result']['packages']
  offerId?: string
}

const MetaOffersDiscountContext = React.createContext<MetaOffersDiscountState>({
  offerId: undefined,
  packages: undefined,
  loading: false,
})

interface Props {
  offerId: string
  packages: App.FeedOperations['getOfferDiscount']['responses']['200']['content']['application/json']['result']['packages']
  children: React.ReactNode
  loading: boolean
}

export function MetaOffersDiscountProvider({ offerId, packages, children, loading }: PropsWithChildren<Props>) {
  return (
    <MetaOffersDiscountContext.Provider value={{ packages, loading, offerId }}>
      {children}
    </MetaOffersDiscountContext.Provider>
  )
}

export function useMetaOffersDiscount() {
  return useContext(MetaOffersDiscountContext)
}

export default MetaOffersDiscountContext
